"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.splice.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _inputCheckbox = require("@citrus/input-checkbox");
var _inputSelect = require("@citrus/input-select");
var _sortable = require("@citrus/sortable");
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _PctyQuestion = require("./PctyQuestion.Common");
require("./index.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctyQuestionStackRank = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionStackRank, _Component);
  var _super = _createSuper(PctyQuestionStackRank);
  function PctyQuestionStackRank(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionStackRank);
    _this = _super.call(this, props);
    var response = props.response && props.response.length <= 0 ? props.options.map(function (x) {
      return {
        optionId: x.id
      };
    }) : props.response;
    var options = [];
    var orderConfirmed = props.response && props.response.length > 0;

    // map the order of the options to display
    if ((0, _isNotNullOrEmpty.default)(response) && (0, _isNotNullOrEmpty.default)(props.options)) {
      response.forEach(function (r) {
        var option = props.options.find(function (o) {
          return o.id === r.optionId;
        });
        if (!!option) {
          options = [].concat((0, _toConsumableArray2.default)(options), [option]);
        }
      });
    }
    _this.state = {
      options: options,
      response: response,
      orderConfirmed: orderConfirmed
    };
    _this.dragTargetId = "drag-target-".concat(_this.props.id);
    _this.onChangeSortable = _this.onChangeSortable.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeOrderSelected = _this.onChangeOrderSelected.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeOrderConfirmed = _this.onChangeOrderConfirmed.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionStackRank, [{
    key: "onChangeSortable",
    value: function onChangeSortable(options) {
      if (this.props.readOnly) return;
      this.setState({
        options: options,
        orderConfirmed: true
      });
      this.props.onResponse(this.props.id, options.map(function (x) {
        return {
          optionId: x.id
        };
      }));
    }
  }, {
    key: "onChangeOrderConfirmed",
    value: function onChangeOrderConfirmed(_ref) {
      var id = _ref.id,
        selected = _ref.selected;
      if (this.props.readOnly) return;
      this.setState({
        orderConfirmed: selected
      });
      this.props.onResponse(this.props.id, this.state.options.map(function (x) {
        return {
          optionId: x.id
        };
      }));
    }
  }, {
    key: "onChangeOrderSelected",
    value: function onChangeOrderSelected(id, selected, item) {
      if (this.props.readOnly) return;
      var newArray = (0, _toConsumableArray2.default)(this.state.options);
      var srcIndex = this.state.options.findIndex(function (x) {
        return x.id === item.id;
      });
      var targetIndex = this.state.options.findIndex(function (x) {
        return x.id === selected.value;
      });
      newArray.splice(srcIndex, 1); // remove the item
      newArray.splice(targetIndex, 0, item); // insert it where they chose

      this.setState({
        options: newArray,
        orderConfirmed: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var getOptions = function getOptions() {
        return _this2.state.options.map(function (item, index) {
          return {
            label: "".concat(index + 1),
            value: item.id
          };
        });
      };
      var renderItem = function renderItem(item, index) {
        return /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Row, null, /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, {
          className: "pcty-hidden-above-mobile",
          style: {
            width: '70px'
          }
        }, /*#__PURE__*/_react.default.createElement(_inputSelect.SelectStatic, {
          automationId: "question-".concat(_this2.props.number, "-stack-rank-select-").concat(index),
          classNameWrapper: "pcty-no-ellipses",
          id: "selector-id-".concat(_this2.props.id),
          onChange: function onChange(selected) {
            return _this2.onChangeOrderSelected(id, selected, item);
          },
          options: getOptions(),
          readOnly: true,
          value: getOptions()[index]
        })), /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, {
          className: index === 0 ? 'pcty-sortable-border-top-v1-3-1' : ''
        }, item.value));
      };
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestion.renderHint)(this.props.id, this.props.hint), (0, _PctyQuestion.renderScenario)(this.props.id, this.props.scenario), (0, _PctyQuestion.renderQuestion)(this.props.id, this.props.number, this.props.question, this.props.required, this.props.readOnly), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_sortable.Sortable, {
        data: this.state.options,
        id: this.dragTargetId,
        disabled: this.props.disabled || this.props.readOnly,
        onChange: this.onChangeSortable,
        renderItem: renderItem,
        automationId: "question-".concat(this.props.number, "-stack-rank-sortable")
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12 pcty-margin-top"
      }, /*#__PURE__*/_react.default.createElement(_inputCheckbox.Checkbox, {
        id: "order-confirmed-id-".concat(this.props.id),
        className: "stack-rank-checkbox",
        onChange: this.onChangeOrderConfirmed,
        disabled: this.props.disabled || this.props.readOnly,
        automationId: "question-".concat(this.props.number, "-stack-rank-other-checkbox"),
        selected: this.state.orderConfirmed
      }, /*#__PURE__*/_react.default.createElement("em", null, this.props.confirmOrderCaption)))));
    }
  }]);
  return PctyQuestionStackRank;
}(_react.Component);
PctyQuestionStackRank.propTypes = {
  /** A hint that you want to give the person answering the question. */
  hint: _propTypes.default.string,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** Whether or not the question will be disabled. */
  disabled: _propTypes.default.bool,
  /** Whether or not the question will be readOnly. */
  readOnly: _propTypes.default.bool,
  /** The question number. */
  number: _propTypes.default.number.isRequired,
  /** Whether or not the question will be displayed as required. */
  required: _propTypes.default.bool,
  /** Callback function that receives response information each time someone interacts with the question. */
  onResponse: _propTypes.default.func.isRequired,
  /** The array of option objects. */
  options: _propTypes.default.array.isRequired,
  /** The question text. */
  question: _propTypes.default.string.isRequired,
  /** The Confirm Order text. */
  confirmOrderCaption: _propTypes.default.string,
  /** An array of response objects that are output from the component. */
  response: _propTypes.default.array,
  /** Some text that sets up your question. */
  scenario: _propTypes.default.string,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionStackRank');
  }
};
PctyQuestionStackRank.defaultProps = {
  scenario: null,
  disabled: false,
  readOnly: false,
  confirmOrderCaption: 'Confirm order after ranking all answers',
  response: [],
  __TYPE: 'PctyQuestionStackRank'
};
var _default = exports.default = PctyQuestionStackRank;